export { default } from "./CarouselArrow";
